import { component, Component, DateType, property } from '../../../concepts/objects';
import { Audited } from '../auditing/Audited';

const voterVoteDef = {
    name: 'VoterVote',
    implements: [Audited],
};

@component(voterVoteDef)
export class VoterVote extends Component implements Audited {

    @property({ type: 'string' })
    public itemId!: string;

    @property({ type: 'string' })
    public userId!: string;

    @property({ type: DateType })
    public created!: Date;

}
